import { AbstractItemValidator } from ".";
import { IDocumentAlert } from "..";
import { CompareDateAlert, CompareDateEmptyAlert } from "../alerts";
import { ICompareDateValidatable, IItem, instanceOfICompareDateValidatable } from "../items";

enum CompareDateResultKind {
  /** 日付比較OKのとき */
  Valid,

  /** 日付は格納されているが比較NGのとき */
  Invalid,

  /** 評価できなかったとき（日付が格納されていないとき） */
  Error,
}

export class CompareDateValidator extends AbstractItemValidator {
  // 条件式と違って返却値が指定されていないので、バックエンドで式を生成するときに決め打ちの値を式に埋め込んでいる
  private readonly _validValue: string = "true";
  private readonly _invalidValue: string = "false";
  
  protected validateItem(item: IItem, itemSetId: number): IDocumentAlert[] {
    if (!instanceOfICompareDateValidatable(item)) { return []; }
    const result = this.toCompareDateResultKind(item);
    if (result === CompareDateResultKind.Valid) {
      return [];
    }
    if (result === CompareDateResultKind.Invalid) {
      const alert = new CompareDateAlert(itemSetId, item as IItem & ICompareDateValidatable);
      return [alert];
    }
    if (item.isCompareDateEmptyCheckEnable) {
      const alert = new CompareDateEmptyAlert(itemSetId, item as IItem & ICompareDateValidatable);
      return [alert];
    }
    return [];
  }

  private toCompareDateResultKind(item: ICompareDateValidatable): CompareDateResultKind {
    const text = item.text();
    if (text === this._validValue) { return CompareDateResultKind.Valid; }
    if (text === this._invalidValue) { return CompareDateResultKind.Invalid; }
    return CompareDateResultKind.Error;
  }
}
